import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/inventories/actions";
import { searchUsers } from "MODULES/users/actions";
import {
  form,
  Form as AppForm,
  AutoCompleteField,
  FormInput
} from "MODULES/shared/components/Forms";
import validate from "./validate";

export class ReserveForSellerForm extends Component {
  state = {
    selectedSeller: {}
  };

  componentWillMount() {
    if (this.props.selectedSeller) {
      this.setState({ selectedSeller: this.props.selectedSeller });
    }
  }

  handleSellerSelected = seller => {
    this.setState({ selectedSeller: seller });
  };

  render() {
    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <div className="row">
            <div className="col-md-12">
              <Field
                name="reserve_for_seller_id"
                label="Reserve For Seller"
                placeholder="Search by Name"
                component={AutoCompleteField}
                search={this.props.queryUsers}
                selectedItem={this.state.selectedSeller}
                formatItem={result => result && result.full_name}
                onItemSelected={i => i && this.handleSellerSelected(i)}
                required
              />
            </div>
            <div className="col-md-12">
              <Field
                name="quantity"
                label="Reserve Qty"
                type="number"
                component={FormInput}
                required
              />
            </div>
          </div>
        </AppForm.Body>
      </AppForm>
    );
  }
}

ReserveForSellerForm.propTypes = {
  queryUsers: PropTypes.func.isRequired,
  selectedSeller: PropTypes.shape({
    id: PropTypes.number,
    full_name: PropTypes.string
  })
};

export default connect(undefined, dispatch => ({
  queryUsers: filter => dispatch(searchUsers(filter)),
  onSubmit: data => dispatch(actions.reserveForSale(data))
}))(
  form({
    form: "editInventorySeller",
    validate
  })(ReserveForSellerForm)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/EditReserveForSeller/ReserveForSellerForm.jsx